<template>
  <div class="contair">
    <div class="content">
      <div class="logoImg">
        <img src="../../assets/images/logo.png" />
      </div>
      <div class="inputContair">
        <div class="titleText">
          <p>恭喜您登陆成功!</p>
          <p>请继续完善个人信息</p>
          <!-- <p>天算 v2019.08.24</p> -->
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="phone">
            <el-input type="text" v-model="ruleForm.phone" autocomplete="off" placeholder="手机"></el-input>
            <i class="iconfont icon-shouji"></i>
          </el-form-item>
          <el-form-item prop="verificate" class="verificate">
            <el-input type="text" v-model="ruleForm.verificate" autocomplete="off" placeholder="验证码" class="codeBox"></el-input>
            <i class="iconfont icon-iconfront-"></i>
            <div class="verification">
              <a :href="'sms:'+ruleForm.phone" class="message">获取验证码</a>
            </div>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item prop="nickname">
            <el-input v-model="ruleForm.nickname" type="text" placeholder="昵称"></el-input>
            <i class="iconfont icon-nicheng"></i>
          </el-form-item>
          <div class="agreeBox">
            <input type="checkbox" @click="agreeTreaty()" /><span>同意用户协议</span>
          </div>
          <el-form-item class="register">
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isdisabled" class="registerButton">完善个人信息</el-button>
            <button class="wait">稍后再完善</button>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
  export default ({
    name: 'wechatLogin',
    components: {

    },
    data() {
      var checkNickname = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入昵称'));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var checkPhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新填写'));
        } else {
          callback();
        }
      };
      var checkVerificate = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          pass: '',
          checkPass: '',
          nickname: '',
          phone: '',
          verificate: ''
        },
        isdisabled: true,
        rules: {
          pass: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            validator: validatePass2,
            trigger: 'blur'
          }],
          nickname: [{
            validator: checkNickname,
            trigger: 'blur'
          }],
          phone: [{
            validator: checkPhone,
            trigger: 'blur'
          }],
          verificate: [{
            validator: checkVerificate,
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      agreeTreaty() {
        if (this.isdisabled == true) {
          this.isdisabled = false;
        } else {
          this.isdisabled = true;
        }
      }
    }
  })
</script>

<style lang="scss" scoped>
  .contair {
    width: 100%;
    height: 100%;
    background: #252B3A;
  }

  .content {
    width: 1280px;
    margin: 0px auto;
    background: #252B3A;
  }

  .logoImg {
    margin: 0px auto;
    background: #252B3A;
    padding-top: 100px;
    width: 100px;
    padding-bottom: 20px;
  }

  .logoImg>img {
    background: #252B3A;
    width: 100px;
  }

  .inputContair {
    margin: 0px auto;
    padding: 20px 30px;
    /* background: #4d587359; */
    background: rgba(77,88,115,0.35);
    width: 460px;
  }

  .titleText {
    color: #ffffff;
    text-align: center;
    padding-bottom: 10px;
  }

  .titleText>p:first-of-type {
    font-size: 32px;
    margin: 0px;
    line-height: 40px;
  }

  .titleText>p:nth-of-type(2) {
    font-size: 32px;
    margin: 0px;
    line-height: 40px;
  }

  .titleText>p:last-of-type {
    font-size: 14px;
    margin: 0px;
    line-height: 20px;
    margin-top: 20px
  }

  .el-form-item__label {
    color: #ffffff;
  }

  >>>.el-form-item__content {
    margin-left: 30px !important;
    display: flex;
  }

  >>>.el-input__inner {
    width: 400px;
    border-radius: $border-radius;
    padding-left: 25px;
  }

  .verificate {
    display: flex;
  }

  .codeBox {
    width: 250px;
    margin-right: 10px;
  }

  >>>.codeBox>.el-input__inner {
    width: 250px
  }

  .verification {
    width: 140px;
    height: 40px;
    text-align: center;
    background: #ffffff;
  }

  .verification>p {
    margin: 0px;
    line-height: 40px;
    font-size: 16px;
  }

  .agreeBox {
    color: #ffffff;
    padding-left: 30px;
  }

  .register {
    margin-top: 20px;
  }

  >>>.register .el-form-item__content {
    width: 400px;
  }

  .register button {
    width: 240px;
    background: $color-primary;
    color: #ffffff;
    border: 1px solid $color-primary;
    font-size: 18px;
    border-radius: $border-radius;
  }

  .register button:hover {
    background: $color-primary-light-1;
  }

  .register .wait {
    width: 150px;
    margin-left: 10px;
    font-size: 18px;
  }

  .wait:hover {
    cursor: pointer;
  }

  .message {
    text-decoration: none;
    font-size: 14px;
  }

  .icon-weixin {
    color: #1afa29;
    background: #ffffff;
    border-radius: 50%;
  }

  .icon-shouji,
  .icon-iconfront-,
  .icon-mima,
  .icon-nicheng {
    position: absolute;
    top: 0px;
    left: 5px;
    font-size: 16px;
    color: #CCCCCC;
    height: 40px;
    width: auto;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/wechatLogin.vue